import type { UseMutationResult } from "@tanstack/react-query"

import { useSolarConcertStatusCommand } from "./solar-concert-application-cache"
import type { SolarConcertApplicationStatusDto } from "../dto/solar-concert.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/** Ask Concert to build the loan documents for an approved application. The server holds the claim, so a retry cannot build a second package. */
export default function useGenerateSolarConcertLoanDocuments(): UseMutationResult<
  SolarConcertApplicationStatusDto,
  unknown,
  { proposalId: string }
> {
  return useSolarConcertStatusCommand(({ proposalId }) =>
    solarProposalService.generateConcertLoanDocuments(proposalId),
  )
}
